export default "__VITE_ASSET__BTs_SYmf__"